import List from '@utils/list'
import { Operation } from '@utils/index'
import http from '@plugin/axios'
import { $t } from '@plugin/i18n'

const { Search, Table, Tabs, Jurisdiction } = List

const search = new Search('contract.template')
  .placeholder('searchPlaceholder')

function handleModify(selection: any[]) {
  const sl = selection.length === 1 ? selection[0] : null
  if (!sl) return true
  if (sl.status === 1) return $t('contract.template.disabledEditor')
  return false
}

function handleDelete(selection: any[]) {
  if (!selection.length) return true
  if (selection.filter(i => i.status === 1).length) return $t('contract.template.disabledDelete')
  return false
}

const jurisdiction = new Jurisdiction()
  .lib('add').to('Contract.Template.Add')
  .lib('modify').modify('Contract.Template.Modify').disabled(handleModify)
  .lib('delete').del('/srmContract/deleteContractTplByIds', process.env.VUE_APP_CONTRACT_API).disabled(handleDelete)

const tabOptions = [{ name: $t('contract.template.tabOptions[0]'), status: '1' }, { name: $t('contract.template.tabOptions[1]'), status: '2' }]
const tabs = new Tabs().api(() => Promise.resolve(tabOptions)).default('1')

async function audit(this: any, row: any) {
  await this.$confirm(this.$t(`contract.template.statusMessage[${row.status}]`))
  await http({
    url: '/srmContract/updateContractTplStatus',
    baseURL: process.env.VUE_APP_CONTRACT_API,
    data: { id: row.id, status: row.status === 1 ? 2 : 1 }
  })
  this.refresh()
}

const operation = new Operation('contract.template')
  .width(100)
  .add('tabOptions[0]').show(item => item.status === 2).handle(audit)
  .add('tabOptions[1]').show(item => item.status === 1).handle(audit)

const table = new Table('contract.template')
  .add('tplNo')
  .add('tplName')
  .add('addByName')
  .add('tplDesc')

function api(data: any): Promise<any> {
  if (data.condition && data.condition.status === undefined) {
    data.condition.status = '1'
  }
  return http({ url: '/srmContract/getContractTplPage', baseURL: process.env.VUE_APP_CONTRACT_API, data })
}

export default new List()
  .api(api)
  .jurisdiction(jurisdiction)
  .search(search)
  .tabs(tabs)
  .table(table)
  .operation(operation)
  .end()
